// @ngInject
function PricelistsApiService(ResourcesService, $q, DSHttpAdapter, DS) {

    var endpoint = 'pricelists';

    return {
        getPricelists: getPricelists,
        getPricelist: ResourcesService.apiFactory.get(endpoint),
        getPricelistBrief: ResourcesService.apiFactory.get(endpoint + '/brief'),
        getPricelistBriefs: ResourcesService.apiFactory.get(endpoint + '/briefs'),
        createPricelist: ResourcesService.apiFactory.create(endpoint, 'Pricelist'),
        updatePricelist: ResourcesService.apiFactory.update(endpoint, 'Pricelist'),
        getCurrencies: ResourcesService.apiFactory.get(endpoint + '/currencies'),
        getLocations: ResourcesService.apiFactory.get(endpoint + '/locations'),
        getSalesChannels: ResourcesService.apiFactory.get(endpoint + '/saleschannels'),
        getProduct: ResourcesService.apiFactory.get(endpoint + '/product'),
        getPsychologicalPrices: ResourcesService.apiFactory.get(endpoint + '/psychologicalprices'),
        getCustomerGroups: ResourcesService.apiFactory.get(endpoint + '/customergroups'),
        getPriceListEditorArticles: getPriceListEditorArticles,
        savePriceListEditorArticles: savePriceListEditorArticles,
        updateOverridePrice: updateOverridePrice, //deprecated #8046
        removeOverridePrice: removeOverridePrice, //deprecated #8046
        getVolumeDiscounts: ResourcesService.apiFactory.get(endpoint + '/volumediscounts')
    };

    function getPricelists(page, filter, pageSize, companyId) {

        var params = {};

        if (page && page > 1) {
            params.page = page - 1;
        }

        if (pageSize && pageSize > 0) {
            params.pageSize = pageSize;
        }

        if (!_.isEmpty(filter)) {
            params.searchTerm = filter;
        }

        var args = { params: params};

        return ResourcesService.apiFactory.get(endpoint)(args);
    }

    function getPriceListEditorArticles(request) {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/editoritems', request).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;

    }


    function savePriceListEditorArticles(editorArticles) {
        var deferred = $q.defer();

        DSHttpAdapter.PUT(DS.defaults.basePath + endpoint + '/editoritems', editorArticles).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    /**
    * @deprecated In devops #8046
    * @param {*} articleId Article id
    * @param {*} locationId Location id
    * @param {*} newPrice New price
    * @returns {*} ''
    */
    function updateOverridePrice(articleId, locationId, newPrice) {
        var deferred = $q.defer();

        var request = {
            articleId: articleId,
            locationId: locationId,
            price: newPrice
        };

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/updatearticlepricelist', request).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    /**
     * @deprecated In devops #8046
     * @param {*} articleId Article id
     * @param {*} locationId Location id
     * @returns {*} ''
     */
    function removeOverridePrice(articleId, locationId) {
        var deferred = $q.defer();

        var request = {
            articleId: articleId,
            locationId: locationId
        };

        DSHttpAdapter.POST(DS.defaults.basePath + endpoint + '/deletearticlepricelist', request).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function handleError(error) {
        return ResourcesService.handleResourceError(error);
    }
}

angular.module('pricelists.api', [])
  .factory('PricelistsApiService', PricelistsApiService);
